import './OldDelegateView.scss'

import React from 'react'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

const OldDelegateView = ({ history }) => {
  const profile = useSelector(state => state.profile)

  return (
    <div className="old-delegate-view">
      <div className="heading-large-medium">¡Hola {profile.firstname + ' ' + profile.lastname}!</div>
      <div className="-description label-extra-large-basic">¡Te damos la bienvenida al sistema de Registro de Equipos y Jugadores de Referee Pro®!</div>
      <div className="-description label-extra-large-basic">Las fechas límite de registro, así como los campos a completar, serán indicados por la Organización de tu Liga. Ante cualquier duda acerca del reglamento para el Registro de Jugadores, favor de contactar directamente a la Organización de tu Liga.</div>
      <div className="-description label-extra-large-basic">Para recibir soporte técnico, favor de enviar un correo a <a href="mailto:soporte@refereepro.com">soporte@refereepro.com</a>, indicar el Nombre de tu Liga y proporcionar un teléfono de contacto para que podamos llamarte a la brevedad posible.</div>
    </div>
  )
}

export default withRouter(OldDelegateView)
